import { Button } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft, faArrowsRotate } from "@fortawesome/free-solid-svg-icons"
import { useHistory } from "react-router-dom"
import './PageHeader.less'

const PageHeader = ({ icon, title, onBack, onReload }) => {
    const history = useHistory()

    const handleBack = () => {
        if (onBack) return onBack()
        history.push('/')
    }

    return (
        <div className="page-header">
            <Button
                shape="circle"
                className="page-header-back"
                aria-label="Back"
                onClick={handleBack}
                icon={<FontAwesomeIcon icon={faChevronLeft} />}
            />
            <div className="page-header-title">
                {icon ? <span className="page-header-icon">{icon}</span> : null}
                <span>{title}</span>
            </div>
            {onReload && (
                <Button
                    shape="circle"
                    className="page-header-reload"
                    aria-label="Reload"
                    onClick={onReload}
                    icon={<FontAwesomeIcon icon={faArrowsRotate} />}
                />
            )}
        </div>
    )
}

export default PageHeader
